import React from 'react';
import * as S from './styles';
import Events from '../../Events';
import Aguas from '../../../front-novo/icons/Aguas.svg';
import Pequi from '../../../front-novo/icons/Pequi.svg';
import Tronco from '../../../front-novo/icons/Tronco.svg';
import Sol from '../../../front-novo/icons/Sol.svg';
import Gaviao from '../../../front-novo/icons/Gaviao.svg';
import bordercardimg from '../../../front-novo/home/bordercardimg.png';
import { useHistory } from 'react-router-dom'; // Importando useHistory para a navegação

function Home5() {
  const history = useHistory(); // Criando uma função de navegação

  const handleNavigation = () => {
    history.push('/events'); // Redireciona para a página /services
  };
  return (
    <S.Main>
      <S.Section>
        <S.TextDiv>
          <h1>Edital</h1>
          {/* <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit </p> */}
          <div>
            <button>
              <a
                href="https://travessias.s3.sa-east-1.amazonaws.com/EDITAL.pdf"
                target="_blank"
                className="ext"
                rel="noreferrer"
              >
                Acesse agora
              </a>
            </button>
          </div>
        </S.TextDiv>
      </S.Section>
    </S.Main>
  );
}

export default Home5;
